import { useNavigate } from 'react-router-dom'
import { useChecklistPendentes } from '@hooks/useChecklistPendentes.js'
import { useAlertas } from '@hooks/useAlertas.js'
import { ROUTES } from '@utils/constants.js'

/** Links para outras fontes de pendência — não misturadas com a lista do canteiro. */
export function PendenciasIntegracaoSection() {
  const navigate = useNavigate()
  const { totalItens: checklistPendentes } = useChecklistPendentes()
  const { totalAtivos: alertasAtivos } = useAlertas(false)

  if (checklistPendentes === 0 && alertasAtivos === 0) return null

  return (
    <section className='cf3-block' aria-labelledby='pend-outras-heading'>
      <h2 id='pend-outras-heading' className='cf3-subsection-title'>
        Em outro lugar
      </h2>
      <p className='cf3-pend-outras__desc'>
        Checklists do guia e avisos automáticos. Não entram nesta lista.
      </p>
      <div className='cf3-shortcuts cf3-pend-outras__links'>
        {checklistPendentes > 0 && (
          <button
            type='button'
            className='cf3-shortcut'
            onClick={() => navigate(ROUTES.CHECKLIST_PENDENTES)}
          >
            <span className='cf3-shortcut__label'>Checklists do guia · {checklistPendentes}</span>
            <span className='cf3-shortcut__desc'>Itens sem marcar na jornada</span>
          </button>
        )}
        {alertasAtivos > 0 && (
          <button type='button' className='cf3-shortcut' onClick={() => navigate(ROUTES.ALERTAS)}>
            <span className='cf3-shortcut__label'>Alertas · {alertasAtivos}</span>
            <span className='cf3-shortcut__desc'>Orçamento, NF e sequência</span>
          </button>
        )}
      </div>
    </section>
  )
}
